import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  Input
} from '@angular/core';

import { Injector } from '@angular/core';
import { ApiCallService } from '../../../../services/api-call.service';
import { CommonService } from '../../../shared/services/common.service';

import { Subject, Subscription, take, takeUntil, timer } from 'rxjs';
import { Application } from 'src/app/enums/application.enums';
import { labels } from './constant';
import { Store } from '@ngrx/store';
import * as fromUserProfile from '../../../shared/user-profile.reducer';
import { NgOtpInputComponent } from 'ng-otp-input';
@Component({
  selector: 'app-verify-otp-modal',
  templateUrl: './verify-otp-modal.component.html',
  styleUrls: ['./verify-otp-modal.component.scss']
})
export class VerifyOTPModalComponent {
  @Output() confirmed = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  @Input() sendOtpAPIUrl = '';
  @Input() sendOtpPayload: any = null;
  @Input() verifyOtpAPIUrl = '';
  @Input() verifyOtpPayload: any = null;

  @ViewChild('updateEmailRef') updateEmailRef;
  @ViewChild(NgOtpInputComponent, { static: false })
  otpInput!: NgOtpInputComponent;
  apiCallService: ApiCallService;

  readonly otpConfig = {
    allowNumbersOnly: true,
    length: 6,
    placeholder: ''
  };
  private destroy$ = new Subject<void>();
  newOtp = '';
  isResend = false;
  counter: number;
  subscription: Subscription;
  labels = labels;
  loggedInUser: any = null;
  isVerificationInProgress = false;

  constructor(
    _injector: Injector,
    private readonly cs: CommonService,
    private readonly store: Store<fromUserProfile.UserProfileState>
  ) {
    this.apiCallService = _injector.get<ApiCallService>(ApiCallService);
  }
  ngOnInit() {
    this.store
      .select(fromUserProfile.getUserProfileItems)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.loggedInUser = res;
      });
  }

  onNewOtpChange(otp) {
    this.newOtp = otp;
  }
  clickEnter(){
    if(this.newOtp?.length !== 6){
      return;
    }
    this.verifyOtp();
  }

  sendOtp() {
    this.apiCallService
      .post(this.sendOtpAPIUrl, this.sendOtpPayload, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res.status) {
            this.timerCheck(Application.ONE_HUNDRED_EIGHTY, true);
            this.cs.showSuccessMessage(res.body);
          } else {
            this.cs.showErrorMessage(res.message || res.body);
          }
        },
        (err) => {
          this.cs.showErrorMessage(err.message);
        }
      );
  }
  verifyOtp() {
    if (this.newOtp?.length !== 6) {
      return;
    }
    this.isVerificationInProgress = true;
    this.apiCallService
      .post(
        this.verifyOtpAPIUrl,
        {
          otp: this.newOtp,
          ...this.sendOtpPayload,
          ...(this.verifyOtpPayload ?? {})
        },
        true
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res.status) {
            this.confirmed.emit();
          }
          this.isVerificationInProgress = false;
        },
        (err) => {
          this.isVerificationInProgress = false;
          this.cs.showErrorMessage(err.message);
        }
      );
  }

  openModal() {
    this.otpInput?.setValue('');
    this.sendOtp();
    this.updateEmailRef?.openModal();
  }
  closeModal() {
    this.updateEmailRef?.closeModal();
  }

  handleCancel() {
    this.closeModal();
    this.canceled.emit();
  }
  timerCheck(timeCounter, isResend) {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.isResend = isResend;
    this.counter = timeCounter;
    this.subscription = timer(Application.ZERO, Application.ONE_THOUSAND)
      .pipe(take(this.counter))
      .subscribe(() => {
        if (this.counter > Application.ZERO) {
          --this.counter;
        }
        if (this.counter === Application.ZERO) {
          this.isResend = false;
          this.counter = 0;
          this.subscription.unsubscribe();
        }
      });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
